import { UserInfo } from '@cartwhl/common/types';
import Avatar from '@cartwhl/ui/atoms/Avatar';
import Text from '@cartwhl/ui/base/Text';

export default function UserDetails({ userInfo }: { userInfo: UserInfo }) {
  return (
    <div className="flex gap-4">
      <Avatar userInfo={userInfo} size={12} />
      <div>
        <Text as="h4" variant="studio/title/lg">
          {userInfo.firstName} {userInfo.lastName}
        </Text>
        <p className="text-[#A7A7A7]">{userInfo.email}</p>
      </div>
    </div>
  );
}
